import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

/**
 * Physical Keys register routes (PRO-357): the list at `keys._`, the full-page
 * order flow at `keys.new._` (PRO-25: a first-class entity creates at
 * `${listPath}/new`, never a modal), and the single view at
 * `keys[':keyId'](id)._`.
 */
export const createRoutesMapKeys = (prefix: string) => ({
  new: pathJoin(prefix)('new').chainWithTitle({
    title: <T _str="Order key" />,
    breadCrumbTitle: <T _str="Order key" />,
  }),
  ':keyId': (keyId: string) =>
    pathJoin(prefix)(keyId).chainWithTitle({
      title: <T _str="Key details" />,
      breadCrumbTitle: <T _str="Details" />,
    }),
})
